import { addToGlobalThisRet } from "@plugins";

function employeesCounter() {
    const photosWraps = document.querySelectorAll(".js-employees-photos");

    if (photosWraps) {
        photosWraps.forEach((wrap) => {
            if (wrap.children.length > 7) {
                const difference = document.createElement("div");

                difference.classList.add("department-card__difference-employees-count");
                difference.innerHTML = `+${wrap.children.length - 7}`;
                wrap.appendChild(difference);

                difference.addEventListener("click", () => {
                    console.log("click");

                    wrap.classList.toggle("expanded");

                    if (wrap.classList.contains("expanded")) {
                        difference.innerHTML = "Свернуть";
                    } else {
                        difference.innerHTML = `+${wrap.children.length - 8}`;
                    }
                });
            }
        });
    }
}

window.addEventListener("load", () => {
    employeesCounter();
});

addToGlobalThisRet(employeesCounter, "employeesCounter");
